// src/components/AiDisclosure.jsx
// Mention de transparence IA (AI Act art. 50) — à poser près de toute sortie IA.
// Rend « ce qui est produit/suggéré/extrait par une IA » immédiatement lisible.
// Doc de référence : ARTKIV_AI_ACT_COMPLIANCE_2026 (§4.1, §12).
//
// Usage : <AiDisclosure type="extracted" status="unreviewed" />
//         <AiDisclosure type="assisted" note="…" confidence={0.82} />
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const GOLD = "#a9843f";
const BORDER = "#e5e0d8";
const CREAM = "#faf6ec";

const TYPE_DEFAULTS = {
  generated: "Généré par IA",
  extracted: "Extrait automatiquement · à vérifier",
  suggested: "Suggestion IA",
  assisted: "Assisté par IA",
  simulation: "Simulation indicative · aucune décision automatique",
};
const STATUS_DEFAULTS = {
  reviewed: "Revu par l'utilisateur",
  expert_validated: "Validé par un expert",
};

export default function AiDisclosure({
  type = "assisted",
  status = "unreviewed",
  confidence,
  compact = false,
  note,
  learnMoreUrl = "/ai-transparency",
  className = "",
  style = {},
}) {
  const { t } = useTranslation();

  const typeLabel = t(`aiDisclosure.type.${type}`, { defaultValue: TYPE_DEFAULTS[type] || TYPE_DEFAULTS.assisted });
  const statusLabel =
    status && STATUS_DEFAULTS[status]
      ? t(`aiDisclosure.status.${status === "expert_validated" ? "expertValidated" : status}`, {
          defaultValue: STATUS_DEFAULTS[status],
        })
      : "";
  const confidencePct =
    typeof confidence === "number" && Number.isFinite(confidence)
      ? Math.round((confidence <= 1 ? confidence * 100 : confidence))
      : null;

  return (
    <div className={className} style={style}>
      <span
        className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full"
        style={{ background: CREAM, color: GOLD, border: `1px solid ${BORDER}` }}
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
          <path d="M12 3l1.9 4.6L18.5 9l-3.6 3 1.1 4.9L12 14.8 8 16.9 9.1 12 5.5 9l4.6-1.4L12 3z" stroke={GOLD} strokeWidth="1.4" strokelinejoin="round" />
        </svg>
        <span>{typeLabel}</span>
        {confidencePct != null && (
          <span style={{ color: "#8a8378" }}>· {t("aiDisclosure.confidence", { defaultValue: "Confiance : {{n}} %", n: confidencePct })}</span>
        )}
        {statusLabel && (
          <span style={{ color: "#6b6459", borderLeft: `1px solid ${BORDER}`, paddingLeft: 6 }}>{statusLabel}</span>
        )}
      </span>

      {!compact && note && (
        <p className="mt-1 text-xs" style={{ color: "#8a8378", lineHeight: 1.5 }}>
          {note}
        </p>
      )}
      {!compact && (
        <Link to={learnMoreUrl} className="mt-1 inline-block text-xs hover:underline" style={{ color: GOLD }}>
          {t("aiDisclosure.learnMore", { defaultValue: "En savoir plus sur l'IA chez ARTKIV" })}
        </Link>
      )}
    </div>
  );
}
